$.fn.servicesDoctorsList = function () {
    const settings = {
        doctorsListSelector: '.js-doctors-list'
    };

    const $self = $(this);

    const $doctorsListFilter = $self.find('.js-doctors-list-filter');
    const $doctorsList = $self.find(settings.doctorsListSelector);
    const $clinicSelect = $doctorsListFilter.find('.js-clinic-select');

    const doctorsApiUrl = $doctorsList.data('doctors-url-api');

    const $spoilerButton = $self.find('.js-doctors-list-spoiler-button');
    const $emptyStub = $self.find('.js-services-doctors-list-module-empty');

    /**
     * Рендер списка докторов
     */
    const updateDoctorsList = function () {
        let data = {
            clinic_id: $clinicSelect.val(),
        };

        $.ajax(doctorsApiUrl, {
            method: 'GET',
            data: data
        }).done((response) => {
            $doctorsList.html(response.html);
            resetSpoiler();
        }).fail((error) => {
            console.error(error);
        });
    };

    const getTotalCardCount = function () {
        return $doctorsList.find('li').length;
    };

    const MinimalCardCountsForSpoiler = {
        DESKTOP: 5,
        SMALL_DESKTOP: 4,
        TABLET: 3,
        MOBILE: 2,
    }

    const getMinimalCardForActiveSpoiler = function () {
        const windowWidth = window.innerWidth;

        if (windowWidth < Tools.md) {
            return MinimalCardCountsForSpoiler.MOBILE;
        }

        if (windowWidth < Tools.lg) {
            return MinimalCardCountsForSpoiler.TABLET;
        }

        if (windowWidth < Tools.xl) {
            return MinimalCardCountsForSpoiler.SMALL_DESKTOP;
        }

        return MinimalCardCountsForSpoiler.DESKTOP;
    };

    const getTotalHeight = function () {
        return $doctorsList.get(0).scrollHeight;
    };

    const getOneRowHeight = function () {
        const card = $doctorsList.find('li').get(0);

        if (!card) {
            return 0;
        }

        const styles = window.getComputedStyle(card);
        let marginTop = styles.getPropertyValue('margin-top').replace(/[^0-9]/g, '');
        let marginBottom = styles.getPropertyValue('margin-bottom').replace(/[^0-9]/g, '');

        marginTop = Number.isNaN(marginTop) ? 0 : Number(marginTop);
        marginBottom = Number.isNaN(marginBottom) ? 0 : Number(marginBottom);

        return card.offsetHeight + marginTop + marginBottom;
    };


    let isOpenSpoiler = false;
    const clickSpoilerButtonHandler = function (evt) {
        evt.preventDefault();

        isOpenSpoiler = !isOpenSpoiler;

        if (!isOpenSpoiler) {
            $spoilerButton.removeClass('open');
            $doctorsList.css('height', `${getOneRowHeight()}px`)
            tools.scrollTo('.js-services-doctors-list-module');
            return;
        }

        $spoilerButton.addClass('open');
        $doctorsList.css('height', `${getTotalHeight()}px`);
    };

    const manageVisibleEmptyStub = function (totalCardCount) {
        if (totalCardCount === 0) {
            $emptyStub.show();
            return;
        }

        $emptyStub.hide();
    };

    const resetSpoiler = function () {
        $doctorsList.css('height', '');
        $doctorsList.css('height', `${getOneRowHeight()}px`);
        $spoilerButton.removeClass('open');
        isOpenSpoiler = false;

        const totalCardCount = getTotalCardCount();

        manageVisibleEmptyStub(totalCardCount);

        if (totalCardCount < getMinimalCardForActiveSpoiler()) {
            $spoilerButton.addClass('hide');
            return;
        }

        $spoilerButton.removeClass('hide');
    };

    const initSpoiler = function () {
        resetSpoiler();
        $emptyStub.hide();
    };

    /**
     * Инициализация
     */
    const init = function () {
        $clinicSelect.on('change', function () {
            updateDoctorsList();
        });

        $spoilerButton.on('click', clickSpoilerButtonHandler);
        initSpoiler();
    };

    init();

    return this;
};

// инициализация
$('.js-services-doctors-list-module').each(function () {
    $(this).servicesDoctorsList();
});
